class MexicoArtProductGallery {
  constructor(root) {
    if (!root || root.dataset.maProductGalleryMounted === 'true') return;

    this.root = root;
    this.grid = root.querySelector('.media-gallery__grid');
    this.zoomDialog = root.querySelector('zoom-dialog dialog');
    this.desktopMq = window.matchMedia('(min-width: 750px)');
    this.reducedMotionMq = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.intervalMs = Number(root.dataset.maGalleryInterval) || 5200;

    if (!this.grid) return;

    this.items = this.getItems();
    if (this.items.length < 2) return;

    root.dataset.maProductGalleryMounted = 'true';
    root.dataset.maGalleryLive = 'true';

    this.isPointerInside = false;
    this.isFocusInside = false;

    this.handlePointerEnter = () => {
      this.isPointerInside = true;
      this.stopRotation();
    };
    this.handlePointerLeave = () => {
      this.isPointerInside = false;
      this.startRotation();
    };
    this.handleFocusIn = () => {
      this.isFocusInside = true;
      this.stopRotation();
    };
    this.handleFocusOut = () => {
      if (!this.root.matches(':focus-within')) {
        this.isFocusInside = false;
        this.startRotation();
      }
    };
    this.handleVisibilityChange = () => {
      if (document.hidden) {
        this.stopRotation();
      } else {
        this.startRotation();
      }
    };
    this.handleZoomDialogClose = () => {
      if (!this.isPointerInside && !this.isFocusInside) {
        this.startRotation();
      }
    };
    this.handleViewportChange = () => {
      this.updateState();

      if (this.isDesktop()) {
        this.startRotation();
      } else {
        this.stopRotation();
      }
    };

    this.root.addEventListener('mouseenter', this.handlePointerEnter);
    this.root.addEventListener('mouseleave', this.handlePointerLeave);
    this.root.addEventListener('focusin', this.handleFocusIn);
    this.root.addEventListener('focusout', this.handleFocusOut);
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
    this.zoomDialog?.addEventListener('close', this.handleZoomDialogClose);
    this.addMediaQueryListener(this.desktopMq, this.handleViewportChange);

    this.items.forEach((item) => {
      const control = item.querySelector('.product-media-container__zoom-button');
      control?.addEventListener('focus', () => {
        this.isFocusInside = true;
        this.stopRotation();
      });
    });

    this.updateState();
    this.startRotation();
  }

  addMediaQueryListener(query, callback) {
    if (typeof query.addEventListener === 'function') {
      query.addEventListener('change', callback);
      return;
    }

    query.addListener(callback);
  }

  isDesktop() {
    return this.desktopMq.matches;
  }

  isInteracting() {
    return this.isPointerInside || this.isFocusInside || this.isZoomDialogOpen();
  }

  getItems() {
    return [...this.grid.querySelectorAll(':scope > .product-media-container')];
  }

  updateState() {
    this.items = this.getItems();

    this.items.forEach((item, index) => {
      item.classList.toggle('is-featured', index === 0 && this.isDesktop());
      item.classList.toggle('is-secondary', index > 0 && this.isDesktop());
    });
  }

  isZoomDialogOpen() {
    return Boolean(this.zoomDialog?.open);
  }

  startRotation() {
    if (!this.isDesktop() || this.reducedMotionMq.matches || document.hidden || this.isInteracting()) return;

    this.stopRotation();
    this.rotationTimer = window.setInterval(() => {
      const items = this.getItems();
      if (items.length > 1) this.promoteItem(items[1]);
    }, this.intervalMs);
  }

  stopRotation() {
    if (!this.rotationTimer) return;

    window.clearInterval(this.rotationTimer);
    this.rotationTimer = null;
  }

  promoteItem(target, { restart = true } = {}) {
    const items = this.getItems();

    if (!this.isDesktop() || !target || items[0] === target) return;

    const firstRects = new Map(items.map((item) => [item, item.getBoundingClientRect()]));
    this.grid.insertBefore(target, items[0]);

    const reorderedItems = this.getItems();
    reorderedItems.forEach((item) => {
      const previousRect = firstRects.get(item);
      const nextRect = item.getBoundingClientRect();

      if (!previousRect || !nextRect) return;

      const deltaX = previousRect.left - nextRect.left;
      const deltaY = previousRect.top - nextRect.top;
      if (!deltaX && !deltaY) return;

      item.animate(
        [
          { transform: `translate(${deltaX}px, ${deltaY}px)` },
          { transform: 'translate(0, 0)' },
        ],
        {
          duration: 520,
          easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
        }
      );
    });

    this.updateState();
    if (restart) this.startRotation();
  }
}

function initMexicoArtProductGalleries() {
  const galleries = document.querySelectorAll(
    "main[data-template='product'] .product-information__media media-gallery.media-gallery--grid"
  );

  galleries.forEach((gallery) => {
    new MexicoArtProductGallery(gallery);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initMexicoArtProductGalleries, { once: true });
} else {
  initMexicoArtProductGalleries();
}

document.addEventListener('shopify:section:load', initMexicoArtProductGalleries);
